// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { LinkTokens } from './type';

const linkTokens: LinkTokens = {
  linkDefaultFontSize: 'Font-14',
  linkSmallFontSize: 'Font-12',
  linkLargeFontSize: 'Font-16',
  linkPrimaryFontColor: 'Brand-6',
  linkPrimaryDisabledFontColor: 'Brand-3',
  linkPrimaryHoverFontColor: 'Brand-5',
  linkPrimaryActiveFontColor: 'Brand-7',
  linkSecondaryFontColor: 'Neutral-text-5',
  linkSecondaryDisabledFontColor: 'Neutral-text-2',
  linkSecondaryHoverFontColor: 'Brand-5',
  linkSecondaryActiveFontColor: 'Brand-7',
  linkDangerFontColor: 'Danger-6',
  linkDangerDisabledFontColor: 'Danger-3',
  linkDangerHoverFontColor: 'Danger-5',
  linkDangerActiveFontColor: 'Danger-7',
  linkWarningFontColor: 'Warning-6',
  linkWarningDisabledFontColor: 'Warning-3',
  linkWarningHoverFontColor: 'Warning-5',
  linkWarningActiveFontColor: 'Warning-7',
  linkSuccessFontColor: 'Success-6',
  linkSuccessDisabledFontColor: 'Success-3',
  linkSuccessHoverFontColor: 'Success-5',
  linkSuccessActiveFontColor: 'Success-7',
};

export default linkTokens;
